document.addEventListener('DOMContentLoaded', function () {
  function readButtonLabel(btn, attributeName, fallback) {
    const rawValue = btn.getAttribute(attributeName);
    if (!rawValue) return fallback;

    try {
      return JSON.parse(rawValue);
    } catch (e) {
      return rawValue;
    }
  }
  // 处理 bundle 按钮的点击事件
  function showTempMsg(container, msg, ok = true) {
    const el = document.createElement('div');
    el.className = 'bundle__msg' + (ok ? ' bundle__msg--ok' : ' bundle__msg--err');
    el.textContent = msg;
    container.appendChild(el);
    setTimeout(()=> el.remove(), 3000);
  }

  // 按钮状态管理（简化版本，无checkmark）
  function setButtonState(btn, state) {
    const textEl = btn.querySelector('.text');
    
    switch(state) {
      case 'loading':
        btn.disabled = true;
        btn.classList.add('disabled');
        if (textEl) {
          textEl.textContent = 'Adding...';
        }
        break;
      case 'success':
        btn.disabled = false;
        btn.classList.remove('disabled');
        if (textEl) {
          textEl.textContent = 'Added';
        }
        
        // 简化版本的状态恢复
        setTimeout(() => {
          if (textEl) {
            textEl.textContent = readButtonLabel(btn, 'data-label', 'Add to cart');
          }
        }, 1000);
        break;
      case 'error':
        btn.disabled = false;
        btn.classList.remove('disabled');
        if (textEl) {
          textEl.textContent = readButtonLabel(btn, 'data-label', 'Add to cart');
        }
        break;
    }
  }

  // 更新购物车状态
  function getSelectedVariant(card) {
    const variantsData = card.querySelector('.product-bundle__variants-data');
    if (!variantsData) return null;

    try {
      const data = JSON.parse(variantsData.textContent);
      const selects = card.querySelectorAll('.product-bundle__select');

      if (selects.length === 0) {
        return data.variants[0] || null;
      }

      if (selects.length === 1) {
        const selectedOption = selects[0].selectedOptions[0];
        if (selectedOption && selectedOption.dataset.variantId) {
          const variantId = parseInt(selectedOption.dataset.variantId, 10);
          return data.variants.find(v => v.id === variantId) || null;
        }
      }

      const selectedOptions = Array.from(selects).map(select => select.value);
      return findVariantByOptions(data.variants, selectedOptions) || null;
    } catch (e) {
      console.error('Failed to parse bundle variant data:', e);
      return null;
    }
  }

  function isBundleBackorderActive(variant) {
    return Boolean(variant && variant.backorder_enabled === true && variant.inventory_quantity <= 0);
  }

  function syncAddButtonState(card, variant) {
    const addBtn = card.querySelector('.product-bundle__add');
    if (!addBtn || !variant) return;

    const addToCartLabel = readButtonLabel(addBtn, 'data-default-label', 'Add to cart');
    const soldOutLabel = readButtonLabel(addBtn, 'data-sold-out-label', 'Sold out');
    const preorderLabel = readButtonLabel(addBtn, 'data-preorder-label', 'Pre Order');
    const textEl = addBtn.querySelector('.text');
    const isBackorderActive = isBundleBackorderActive(variant);

    let nextLabel = addToCartLabel;
    let isDisabled = false;

    if (isBackorderActive) {
      nextLabel = preorderLabel;
    } else if (!variant.available) {
      nextLabel = soldOutLabel;
      isDisabled = true;
    }

    addBtn.classList.toggle('button--preorder', isBackorderActive);
    addBtn.classList.toggle('disabled', isDisabled);
    addBtn.disabled = isDisabled;
    addBtn.setAttribute('data-label', JSON.stringify(nextLabel));

    if (textEl) {
      textEl.textContent = nextLabel;
    }
  }

  function updateCartState() {
    if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
      // 显示购物车抽屉
      window.PXUTheme.jsAjaxCart.showDrawer();
      
      // 更新购物车视图
      window.PXUTheme.jsAjaxCart.updateView();
      
      // 更新购物车数量
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const cartTrigger = document.querySelector('[data-ajax-cart-trigger]');
          const itemCountElements = document.querySelectorAll('[data-bind="itemCount"]');
          
          // 更新购物车计数显示
          itemCountElements.forEach(el => {
            el.textContent = cart.item_count;
          });
          
          // 更新购物车图标状态
          if (cartTrigger) {
            if (cart.item_count > 0) {
              cartTrigger.classList.add('has-cart-count');
            } else {
              cartTrigger.classList.remove('has-cart-count');
            }
          }
        })
        .catch(err => {
          console.error('Failed to update cart count:', err);
        });
    }
  }

  // 根据选择的选项找到对应的 variant
  function findVariantByOptions(variants, selectedOptions) {
    if (!selectedOptions || selectedOptions.length === 0) {
      return variants[0];
    }

    return variants.find(variant => {
      for (let i = 0; i < selectedOptions.length; i++) {
        const selectedValue = selectedOptions[i];
        const variantOption = variant.options[i];
        
        if (selectedValue !== variantOption) {
          return false;
        }
      }
      return true;
    });
  }

  // 获取当前选中的 variant ID
  function getCurrentVariantId(card) {
    const variantsData = card.querySelector('.product-bundle__variants-data');
    if (!variantsData) return null;

    try {
      const data = JSON.parse(variantsData.textContent);
      const selects = card.querySelectorAll('.product-bundle__select');
      
      if (selects.length === 0) {
        // 没有选项，返回第一个 variant
        return data.variants[0]?.id;
      }

      // 检查是否有直接的 variant ID（用于简化的选择器）
      if (selects.length === 1) {
        const selectedOption = selects[0].selectedOptions[0];
        if (selectedOption && selectedOption.dataset.variantId) {
          return parseInt(selectedOption.dataset.variantId);
        }
      }

      const selectedOptions = Array.from(selects).map(select => select.value);
      const variant = findVariantByOptions(data.variants, selectedOptions);
      
      return variant?.id || null;
    } catch (e) {
      console.error('Failed to parse variants data:', e);
      return null;
    }
  }

  // 获取当前选中 variant 的库存信息
  function getCurrentVariantInventory(card) {
    const variantsData = card.querySelector('.product-bundle__variants-data');
    if (!variantsData) return null;

    try {
      const data = JSON.parse(variantsData.textContent);
      const selects = card.querySelectorAll('.product-bundle__select');
      
      let variant;
      if (selects.length === 0) {
        variant = data.variants[0];
      } else if (selects.length === 1) {
        const selectedOption = selects[0].selectedOptions[0];
        if (selectedOption && selectedOption.dataset.variantId) {
          const variantId = parseInt(selectedOption.dataset.variantId);
          variant = data.variants.find(v => v.id === variantId);
        }
      }
      
      if (!variant) {
        const selectedOptions = Array.from(selects).map(select => select.value);
        variant = findVariantByOptions(data.variants, selectedOptions);
      }

      return variant ? {
        inventory_quantity: variant.inventory_quantity,
        inventory_management: variant.inventory_management,
        inventory_policy: variant.inventory_policy
      } : null;
    } catch (e) {
      console.error('Failed to get variant inventory:', e);
      return null;
    }
  }

  // 确保数量输入框的值始终是有效的
  function ensureValidQuantity(qtyInput) {
    if (!qtyInput) return;
    
    const currentValue = parseInt(qtyInput.value);
    
    // 如果值无效、为0或小于1，设置为1
    if (isNaN(currentValue) || currentValue <= 0) {
      qtyInput.value = 1;
    }
    
    // 确保至少为最小值
    const minValue = parseInt(qtyInput.getAttribute('min')) || 1;
    if (parseInt(qtyInput.value) < minValue) {
      qtyInput.value = minValue;
    }
  }

  // 更新数量控制按钮状态
  function updateQuantityControls(card) {
    const inventory = getCurrentVariantInventory(card);
    const qtyInput = card.querySelector('[data-quantity-input]');
    const plusBtn = card.querySelector('.qty-plus');
    const minusBtn = card.querySelector('.qty-minus');
    
    if (!qtyInput || !plusBtn || !minusBtn) return;

    // 首先确保数量值是有效的
    ensureValidQuantity(qtyInput);
    
    const currentQty = parseInt(qtyInput.value) || 1;
    
    // 检查库存限制
    let maxAvailable = null;
    let shouldLimitQuantity = false;
    
    if (inventory && inventory.inventory_management === 'shopify') {
      if (inventory.inventory_policy === 'deny') {
        // 拒绝超额销售：使用实际库存数量
        maxAvailable = inventory.inventory_quantity;
        shouldLimitQuantity = true;
      } else if (inventory.inventory_policy === 'continue') {
        // 允许超额销售（sell when out of stock）：设置合理的最大值用于布局稳定性
        // 如果有库存，使用库存数量；如果没库存，设置默认最大值
        maxAvailable = inventory.inventory_quantity > 0 ? inventory.inventory_quantity : 999;
        shouldLimitQuantity = false; // 不实际限制数量，只为布局设置max属性
      }
    } else {
      // 没有库存管理或非Shopify管理：设置默认最大值
      maxAvailable = 999;
      shouldLimitQuantity = false;
    }

    // 如果需要限制数量且输入数量超过库存，强制设为最大库存
    if (shouldLimitQuantity && maxAvailable !== null && currentQty > maxAvailable) {
      qtyInput.value = maxAvailable;
    }

    // 更新加号按钮状态
    const finalQty = parseInt(qtyInput.value) || 1;
    if (shouldLimitQuantity && maxAvailable !== null && finalQty >= maxAvailable) {
      plusBtn.disabled = true;
      plusBtn.classList.add('disabled');
      plusBtn.title = `Maximum available: ${maxAvailable}`;
    } else {
      plusBtn.disabled = false;
      plusBtn.classList.remove('disabled');
      plusBtn.title = '';
    }

    // 更新减号按钮状态
    if (finalQty <= 1) {
      minusBtn.disabled = true;
      minusBtn.classList.add('disabled');
    } else {
      minusBtn.disabled = false;
      minusBtn.classList.remove('disabled');
    }

    // 始终设置max属性以确保布局稳定性
    if (maxAvailable !== null) {
      qtyInput.setAttribute('max', maxAvailable);
    } else {
      qtyInput.setAttribute('max', '999'); // fallback默认值
    }
  }

  // 更新价格显示
  function updatePrice(card) {
    const variantsData = card.querySelector('.product-bundle__variants-data');
    const priceEl = card.querySelector('.product-bundle__price');
    
    if (!variantsData || !priceEl) return;

    try {
      const data = JSON.parse(variantsData.textContent);
      const selects = card.querySelectorAll('.product-bundle__select');
      
      let variant;
      
      if (selects.length === 0) {
        variant = data.variants[0];
      } else if (selects.length === 1) {
        const selectedOption = selects[0].selectedOptions[0];
        if (selectedOption && selectedOption.dataset.variantId) {
          const variantId = parseInt(selectedOption.dataset.variantId);
          variant = data.variants.find(v => v.id === variantId);
        }
      }
      
      if (!variant) {
        const selectedOptions = Array.from(selects).map(select => select.value);
        variant = findVariantByOptions(data.variants, selectedOptions);
      }

      if (variant) {
        const priceHTML = variant.compare_at_price && variant.compare_at_price !== variant.price
          ? `<span class="money compare-price">$${(variant.compare_at_price / 100).toFixed(2)}</span>
             <span class="money sale-price">$${(variant.price / 100).toFixed(2)}</span>`
          : `<span class="money">$${(variant.price / 100).toFixed(2)}</span>`;
        
        priceEl.innerHTML = priceHTML;
        
        // 更新按钮状态
        const addBtn = card.querySelector('.product-bundle__add');
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.classList.remove('disabled');
          } else {
            addBtn.disabled = true;
            addBtn.classList.add('disabled');
          }
        }
        
        // 更新数量控制按钮状态
        updateQuantityControls(card);
      }
    } catch (e) {
      console.error('Failed to update price:', e);
    }
  }

  // 更新选项可用性 - 智能联动选择
  function updateOptionAvailability(card) {
    const variantsData = card.querySelector('.product-bundle__variants-data');
    const selects = card.querySelectorAll('.product-bundle__select');
    
    if (!variantsData || selects.length === 0) return;

    try {
      const data = JSON.parse(variantsData.textContent);
      
      // 获取当前所有选择的值
      const currentSelections = Array.from(selects).map(select => select.value);
      
      // 为每个选项框更新可用选项
      selects.forEach((select, selectIndex) => {
        Array.from(select.options).forEach(option => {
          // 创建测试选项组合
          const testOptions = [...currentSelections];
          testOptions[selectIndex] = option.value;
          
          // 检查是否存在匹配且可用的 variant
          const hasAvailableVariant = data.variants.some(variant => {
            // 检查是否所有选项都匹配
            const matches = testOptions.every((value, i) => {
              return variant.options[i] === value;
            });
            return matches && variant.available;
          });
          
          // 更新选项状态
          option.disabled = !hasAvailableVariant;
          
          // 更新选项文本（添加或移除 "Sold out" 标记）
          const baseText = option.value;
          if (!hasAvailableVariant) {
            if (!option.textContent.includes('(Sold out)')) {
              option.textContent = baseText + ' (Sold out)';
            }
          } else {
            option.textContent = baseText;
          }
        });
        
        // 如果当前选择的选项现在不可用，自动选择第一个可用的选项
        if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
          const firstAvailable = Array.from(select.options).find(opt => !opt.disabled);
          if (firstAvailable) {
            select.value = firstAvailable.value;
            // 递归调用以更新其他选项（因为这个选择改变了）
            setTimeout(() => {
              updateOptionAvailability(card);
              updatePrice(card);
              updateQuantityControls(card);
            }, 0);
            return;
          }
        }
      });
      
    } catch (e) {
      console.error('Failed to update option availability:', e);
    }
  }

  // 数量控制处理
  function initQuantityControls(card) {
    const minusBtns = card.querySelectorAll('.qty-minus');
    const plusBtns = card.querySelectorAll('.qty-plus');
    const qtyInputs = card.querySelectorAll('[data-quantity-input]');
    
    // 首先确保所有数量输入框都有正确的初始值
    qtyInputs.forEach(input => {
      ensureValidQuantity(input);
    });
    
    minusBtns.forEach(btn => {
      // 避免重复绑定
      if (btn.dataset.initialized) return;
      btn.dataset.initialized = 'true';
      
      btn.addEventListener('click', function() {
        const target = document.getElementById(btn.dataset.target);
        if (target) {
          const currentValue = parseInt(target.value) || 1;
          const minValue = parseInt(target.getAttribute('min')) || 1;
          if (currentValue > minValue) {
            target.value = currentValue - 1;
            // 触发数量变化后更新按钮状态
            updateQuantityControls(card);
          }
        }
      });
    });

    plusBtns.forEach(btn => {
      // 避免重复绑定
      if (btn.dataset.initialized) return;
      btn.dataset.initialized = 'true';
      
      btn.addEventListener('click', function() {
        if (btn.disabled) return; // 如果按钮被禁用，直接返回
        
        const target = document.getElementById(btn.dataset.target);
        if (target) {
          const currentValue = parseInt(target.value) || 1;
          const maxValue = target.getAttribute('max') ? parseInt(target.getAttribute('max')) : null;
          
          // 检查是否可以增加数量
          if (maxValue === null || currentValue < maxValue) {
            target.value = currentValue + 1;
            // 触发数量变化后更新按钮状态
            updateQuantityControls(card);
          }
        }
      });
    });

    // 监听数量输入框的直接输入
    qtyInputs.forEach(input => {
      if (input.dataset.initialized) return;
      input.dataset.initialized = 'true';
      
      input.addEventListener('input', function() {
        // 验证并限制输入值
        ensureValidQuantity(input);
        
        const inventory = getCurrentVariantInventory(card);
        let maxAvailable = null;
        if (inventory && inventory.inventory_management === 'shopify' && inventory.inventory_policy === 'deny') {
          maxAvailable = inventory.inventory_quantity;
        }
        
        const currentValue = parseInt(input.value) || 1;
        if (maxAvailable !== null && currentValue > maxAvailable) {
          input.value = maxAvailable;
        }
        
        updateQuantityControls(card);
      });
      
      input.addEventListener('change', function() {
        // 验证并限制输入值
        ensureValidQuantity(input);
        
        const inventory = getCurrentVariantInventory(card);
        let maxAvailable = null;
        if (inventory && inventory.inventory_management === 'shopify' && inventory.inventory_policy === 'deny') {
          maxAvailable = inventory.inventory_quantity;
        }
        
        const currentValue = parseInt(input.value) || 1;
        if (maxAvailable !== null && currentValue > maxAvailable) {
          input.value = maxAvailable;
        }
        
        updateQuantityControls(card);
      });

      // 处理失焦事件，确保值始终有效
      input.addEventListener('blur', function() {
        ensureValidQuantity(input);
        updateQuantityControls(card);
      });
    });
    
    // 初始化时更新一次按钮状态
    updateQuantityControls(card);
  }

  // 选择第一个可用的 variant 组合
  function selectFirstAvailableVariant(card) {
    const variantsData = card.querySelector('.product-bundle__variants-data');
    const selects = card.querySelectorAll('.product-bundle__select');
    
    if (!variantsData || selects.length === 0) return;

    try {
      const data = JSON.parse(variantsData.textContent);
      
      // 找到第一个可用的 variant
      const firstAvailableVariant = data.variants.find(variant => variant.available);
      
      if (firstAvailableVariant) {
        // 根据第一个可用 variant 的选项来设置选择器
        selects.forEach((select, index) => {
          const targetValue = firstAvailableVariant.options[index];
          if (targetValue) {
            // 检查这个值在选择器中是否存在且可用
            const matchingOption = Array.from(select.options).find(option => 
              option.value === targetValue && !option.disabled
            );
            if (matchingOption) {
              select.value = targetValue;
            }
          }
        });
      }
    } catch (e) {
      console.error('Failed to select first available variant:', e);
    }
  }

  // 智能联动选择 - 为特定选项找到最佳可用值
  function findBestAvailableOptionValue(card, changedSelectIndex) {
    const variantsData = card.querySelector('.product-bundle__variants-data');
    const selects = card.querySelectorAll('.product-bundle__select');
    
    if (!variantsData) return;

    try {
      const data = JSON.parse(variantsData.textContent);
      const currentSelections = Array.from(selects).map(select => select.value);
      
      // 为除了当前改变的选项之外的每个选项，找到最佳可用值
      selects.forEach((select, selectIndex) => {
        if (selectIndex === changedSelectIndex) return; // 跳过触发改变的选项
        
        // 检查当前选择是否仍然可用
        const testOptions = [...currentSelections];
        const hasAvailableVariant = data.variants.some(variant => {
          const matches = testOptions.every((value, i) => variant.options[i] === value);
          return matches && variant.available;
        });
        
        // 如果当前组合不可用，为这个选项找到最佳可用值
        if (!hasAvailableVariant) {
          let bestValue = null;
          
          // 遍历这个选项的所有可能值
          Array.from(select.options).forEach(option => {
            const testOptions = [...currentSelections];
            testOptions[selectIndex] = option.value;
            
            const isAvailable = data.variants.some(variant => {
              const matches = testOptions.every((value, i) => variant.options[i] === value);
              return matches && variant.available;
            });
            
            if (isAvailable && !bestValue) {
              bestValue = option.value;
            }
          });
          
          // 如果找到了更好的值，更新选择
          if (bestValue && bestValue !== select.value) {
            select.value = bestValue;
            currentSelections[selectIndex] = bestValue;
          }
        }
      });
    } catch (e) {
      console.error('Failed to find best available option values:', e);
    }
  }

  // 初始化 variant 选择器 - 智能联动版本
  function initVariantSelectors(card) {
    const selects = card.querySelectorAll('.product-bundle__select');
    
    selects.forEach((select, index) => {
      // 避免重复绑定
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      
      select.addEventListener('change', function() {
        // 智能联动：当任意选项改变时，其他选项自动选择最佳可用值
        findBestAvailableOptionValue(card, index);
        
        // 更新所有选项的可用性状态
        updateOptionAvailability(card);
        updatePrice(card);
        updateQuantityControls(card);
      });
    });
    
    // 初始化时先选择第一个可用的 variant
    selectFirstAvailableVariant(card);
    
    // 然后更新界面
    updatePrice(card);
    updateOptionAvailability(card);
    updateQuantityControls(card);
  }

  // 初始化 bundle 按钮
  function getCurrentVariantId(card) {
    const variant = getSelectedVariant(card);
    return variant ? variant.id : null;
  }

  function getCurrentVariantInventory(card) {
    try {
      const variant = getSelectedVariant(card);
      return variant ? {
        inventory_quantity: variant.inventory_quantity,
        inventory_management: variant.inventory_management,
        inventory_policy: variant.inventory_policy
      } : null;
    } catch (e) {
      console.error('Failed to get variant inventory:', e);
      return null;
    }
  }

  function updatePrice(card) {
    const variant = getSelectedVariant(card);
    const priceEl = card.querySelector('.product-bundle__price');

    if (!variant || !priceEl) return;

    const priceHTML = variant.compare_at_price && variant.compare_at_price !== variant.price
      ? `<span class="money compare-price">$${(variant.compare_at_price / 100).toFixed(2)}</span>
         <span class="money sale-price">$${(variant.price / 100).toFixed(2)}</span>`
      : `<span class="money">$${(variant.price / 100).toFixed(2)}</span>`;

    priceEl.innerHTML = priceHTML;
    syncAddButtonState(card, variant);
    updateQuantityControls(card);
  }

  function initializeBundleButtons() {
    document.querySelectorAll('.product-bundle__add').forEach(btn => {
      const handle = btn.dataset.handle;
      const card = btn.closest('.product-bundle__card');
      if (!handle || !card) return;

      // 检查按钮是否已经初始化，避免重复绑定
      if (btn.dataset.bundleInitialized) return;
      btn.dataset.bundleInitialized = 'true';

      // 初始化数量控制和选项选择器
      initQuantityControls(card);
      initVariantSelectors(card);

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // 防止重复点击
        if (btn.disabled || btn.classList.contains('processing')) return;
        
        setButtonState(btn, 'loading');

        // 获取选中的 variant ID 和数量
        const variantId = getCurrentVariantId(card);
        const qtyInput = card.querySelector('[data-quantity-input]');
        
        // 确保数量值是有效的
        ensureValidQuantity(qtyInput);
        const quantity = parseInt(qtyInput?.value) || 1;

        if (!variantId) {
          setButtonState(btn, 'error');
          showTempMsg(card, 'Please select all options', false);
          return;
        }

        // 直接通过 Ajax 添加到购物车
        // 使用主题的 Ajax Cart 系统添加到购物车
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          // 使用主题期望的序列化数据格式
          const formData = `id=${encodeURIComponent(variantId)}&quantity=${encodeURIComponent(quantity)}`;
          
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: formData,
            success: function(product) {
              setButtonState(btn, 'success');
              
              // 使用主题的购物车更新方法 - 与主产品表单一致的时序
              setTimeout(() => {
                window.PXUTheme.jsAjaxCart.showDrawer();
                window.PXUTheme.jsAjaxCart.updateView();
              }, 1000); // 与主产品按钮的延时保持一致
            },
            error: function(XMLHttpRequest) {
              console.error('Bundle add error', XMLHttpRequest);
              setButtonState(btn, 'error');
              
              let errorMsg = 'Add failed';
              try {
                const response = eval('(' + XMLHttpRequest.responseText + ')');
                errorMsg = response.description || errorMsg;
              } catch(e) {
                errorMsg = 'Add failed';
              }
              
              showTempMsg(card, errorMsg, false);
            }
          });
        } else {
          // 回退到原生 fetch 方法
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
              id: variantId, 
              quantity: quantity 
            })
          })
          .then(r => {
            if (!r.ok) throw new Error('Add to cart failed');
            return r.json();
          })
          .then(data => {
            setButtonState(btn, 'success');
            // 延时更新购物车状态
            setTimeout(() => {
              updateCartState();
            }, 1000);
          })
          .catch(err => {
            console.error('Bundle add error', err);
            setButtonState(btn, 'error');
            showTempMsg(card, 'Add failed', false);
          });
        }
      });
    });
  }

  // 页面加载完成后初始化
  initializeBundleButtons();
  
  // 定期检查新添加的按钮（简单且安全的方法）
  setInterval(() => {
    initializeBundleButtons();
  }, 2000);
});
